import { render, staticRenderFns } from "./CreateBarcodeOrderFromHeaderNumberModal.vue?vue&type=template&id=2c4fb33a"
import script from "./CreateBarcodeOrderFromHeaderNumberModal.vue?vue&type=script&lang=ts"
export * from "./CreateBarcodeOrderFromHeaderNumberModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports